// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__9xQRb","productName":"Table_productName__1n0Jq"};